/* eslint-disable max-classes-per-file */
import { getOssToken } from '../security/tokenHelper';

class Exception {
  constructor(message) {
    this.message = message;
  }
}

export class NotFoundException extends Exception {}
export class ForbiddenException extends Exception {}
export class UnauthorizedException extends Exception {}

const buildHeaders = additionalHeaders => {
  const headers = new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  });

  Object.keys(additionalHeaders).forEach(key => {
    headers.append(key, additionalHeaders[key]);
  });

  // if (true) {
  // IE check here
  headers.append('Pragma', 'no-cache');
  headers.append('Cache-Control', 'no-cache');
  headers.append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
  // }

  return headers;
};

const getParser = headers => {
  const contentType = headers.get('Content-Type');
  return !!contentType && contentType.includes('application/json') ? 'json' : 'text';
};

const parse = res => res[getParser(res.headers)]();

const buildOptions = (action, requestBody, requestOptions) => {
  const { headers, ...otherOptions } = requestOptions || {};

  const options = {
    method: action,
    ...otherOptions,
    mode: 'cors',
    ...(!!requestBody && {
      body: typeof requestBody === 'object' ? JSON.stringify(requestBody) : requestBody,
    }),
    headers: buildHeaders(headers || {}),
  };

  const token = getOssToken();
  if (token) {
    options.headers.append('Authorization', `${token}`);
  }

  return options;
};

export function* handleResponse(res) {
  const body = yield parse(res);
  if (res.ok) {
    return body;
  }
  if (res.status === 401) {
    // yield call(handleUnauthorizedSaga);
    throw new UnauthorizedException();
  } else if (res.status === 404) {
    throw new NotFoundException('Resource not found.');
  } else {
    throw body;
  }
}

export function handleDownloadResponse(res) {
  if (res.ok) {
    const data = {
      name: res.headers.get('X-File-Name'),
      blob: res.blob(),
    };

    data.blob.then(blob => {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, data.name);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = data.name;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); // afterwards we remove the element again
      }
    });

    return { name: data.name };
  }
  if (res.status === 401) {
    // yield call(handleUnauthorizedSaga);
    throw new UnauthorizedException();
  } else if (res.status === 404) {
    throw new NotFoundException('Resource not found.');
  } else {
    throw new Exception('Problem');
  }
}

export const get = ({ url, requestOptions }) => {
  return fetch(url, buildOptions('GET', null, requestOptions));
};

export const post = ({ url, data, requestOptions }) => {
  return fetch(url, buildOptions('POST', data, requestOptions));
};

export const put = ({ url, data, requestOptions }) => {
  return fetch(url, buildOptions('PUT', data, requestOptions));
};

export const remove = ({ url, requestOptions }) => {
  return fetch(url, buildOptions('DELETE', null, requestOptions));
};
